import { StyleSheet } from 'aphrodite';
import Background from './images/background.png';
import DialogBackground from './images/popupBackground.png';

export const Flexbox = StyleSheet.create({
  row: {
    display: 'flex',
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
  },
  wrap: {
    flexWrap: 'wrap'
  },
  axisStart: {
    justifyContent: 'flex-start'
  },
  axisEnd: {
    justifyContent: 'flex-end'
  },
  axisCenter: {
    justifyContent: 'center'
  },
  axisFill: {
    justifyContent: 'space-around'
  },
  axisBetween: {
    justifyContent: 'space-between'
  },
  crossStart: {
    alignItems: 'flex-start',
  },
  crossCenter: {
    alignItems: 'center',
  },
  crossFill: {
    alignItems: 'stretch',
  },
  crossBaseline: {
    alignItems: 'baseline',
  },
  fillVertical: {
    height: '100%'
  },
  grow: {
    flexGrow: 1
  },
  selfStart: {
    alignSelf: 'flex-start'
  },
  centeredItem: {
    maxWidth: '100%'
  }
});

export const Color = {
  primary: '#0C73AA',
  primaryInverse: '#FFFFFF',
  secondary: '#00ACCF',
  accent: '#A0DBFA',
};

export const ColorEnvironment = StyleSheet.create({
  normal: {
    color: Color.primary,
    backgroundColor: Color.primaryInverse
  },
  transparent: {
    color: Color.primary
  },
  inverse: {
    color: Color.primaryInverse,
    backgroundColor: Color.primary
  },
  secondaryInverse: {
    color: Color.primaryInverse,
    backgroundColor: Color.secondary
  }
});

export const Font = StyleSheet.create({
  body: {
    fontFamily: 'Tahoma, Verdana, sans-serif',
    fontSize: 18
  },

  largeHeading: {
    fontFamily: 'Tahoma, Verdana, sans-serif',
    fontWeight: 'bold',
    fontSize: 30
  },

  heading: {
    fontFamily: 'Tahoma, Verdana, sans-serif',
    fontWeight: 'bold',
    fontSize: 18
  },

  label: {
    fontFamily: 'Tahoma, Verdana, sans-serif',
    fontWeight: 'bold',
    fontSize: 12
  },

  tinyLabel: {
    fontFamily: 'Tahoma, Verdana, sans-serif',
    fontSize: 9
  },

  hero: {
    fontFamily: '"Arial Black", "Arial-BoldMT", sans-serif',
    fontWeight: 'bold',
    color: Color.primary,
    fontSize: 48,
    textTransform: 'uppercase',
    textShadow: `3px 3px ${Color.accent}`
  },

  scoreboardHero: {
    fontFamily: '"Arial Black", "Arial-BoldMT", sans-serif',
    fontWeight: 'bold',
    color: Color.primary,
    fontSize: 30,
    textTransform: 'uppercase',
    textShadow: `3px 3px ${Color.accent}`
  },

  heroInset: {
    paddingLeft: '0.5ex'
  },

  cardHero: {
    fontFamily: 'Tahoma, Verdana, sans-serif',
    fontWeight: 'bold',
    color: Color.primaryInverse,
    fontSize: 24,
    textTransform: 'uppercase',
    textAlign: 'center',
    textShadow: '2px 2px 4px rgba(0, 0, 0, 0.4)'
  },

  tight: {
    lineHeight: 0.85
  },

  button: {
    fontFamily: '"Arial Black", "Arial-BoldMT", sans-serif',
    fontWeight: 'bold',
    color: Color.primaryInverse,
    fontSize: 28,
    textTransform: 'uppercase',
    textShadow: '3px 3px rgba(0, 0, 0, 0.4)',
    textDecoration: 'none',
    '@media (max-width: 320px)': {
      fontSize: 18,
    }
  }
});

export const Text = StyleSheet.create({
 textBlock: {
    width: '90%',
    maxWidth: 600,
    textAlign: 'center',
    paddingLeft: 10,
    paddingRight: 10,
    paddingBottom: 10
  },
  heading: {
    textAlign: 'center',
    paddingLeft: 10,
    paddingRight: 10,
    marginBottom: 30
  }
});

export const Control = StyleSheet.create({
  heroImage: {
    height: 260,
    width: 260,
    borderRadius: '100%',
    border: `5px solid ${Color.primary}`,
    boxShadow: '0px 0px 14px 6px rgba(0, 0, 0, 0.16)',
    '@media (max-width: 320px)': {
      width: 130,
      height: 130,
      border: `3px solid ${Color.primary}`,
    }
  },
  inlineButton: {
    padding: 10,
    backgroundColor: Color.secondary,
    color: Color.primaryInverse,
    borderRadius: 5,
    fontFamily: '"Arial Black", "Arial-BoldMT", sans-serif',
    fontWeight: 'bold',
    fontSize: 18,
    boxShadow: '0px 0px 8px 6px rgba(0, 0, 0, 0.1)'
  }
});

export const ReportBox = StyleSheet.create({
  container: {
    width: 'calc(100% - 20px)',
    maxWidth: 500,
    '@media (min-height: 600px)': {
      minHeight: 400,
    },
    marginTop: 60,
    '@media (max-width: 400px)': {
      marginTop: 20,
    },
    marginLeft: 10,
    marginRight: 10,
    backgroundColor: Color.primaryInverse,
    borderRadius: '10px',
    border: `6px solid ${Color.primary}`,
    boxShadow: '0px 0px 8px 6px rgba(0, 0, 0, 0.1)'
  },
  topImage: {
    position: 'relative',
    top: -65,
    width: 130,
    height: 130,
    borderRadius: '100%',
    backgroundColor: Color.primary,
    border: `6px solid ${Color.primary}`,
    '@media (max-width: 400px)': {
      top: -32.5,
      width: 65,
      height: 65,
      border: `3px solid ${Color.primary}`,
    }
  },
  topImageInverted: {
    position: 'relative',
    top: -65,
    width: 130,
    height: 130,
    borderRadius: '100%',
    backgroundColor: Color.primaryInverse,
    border: `6px solid ${Color.primary}`,
    '@media (max-width: 400px)': {
      top: -32.5,
      width: 65,
      height: 65,
      border: `3px solid ${Color.primary}`,
    }
  }
});

export const Dialog = StyleSheet.create({
  container: {
    width: 'calc(100% - 20px)',
    maxWidth: 500,
    minHeight: 200,
    marginLeft: 10,
    marginRight: 10,
    backgroundColor: Color.primaryInverse,
    backgroundImage: `url(${DialogBackground})`,
    backgroundSize: '350px 350px',
    borderRadius: '10px',
    border: `3px solid ${Color.primary}`,
    boxShadow: '0px 0px 8px 6px rgba(0, 0, 0, 0.1)'
  }
});

export const Layout = StyleSheet.create({
  body: {
    width: '100%',
    height: '100vh',
    userSelect: 'none',
    backgroundImage: `url(${Background})`,
    backgroundSize: '740px 740px',
    '@media (max-width: 420px)': {
      paddingTop: 16,
      backgroundSize: '370px 370px',
    },
  },
  fullScrollingContentArea: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    paddingBottom: 60,
    overflowX: 'auto'
  },
  scrollingContentArea: {
    position: 'absolute',
    '@media (max-width: 760px)': {
      top: 90,
    },
    '@media (min-width: 760px)': {
      top: 150,
    },
    bottom: 0,
    left: 0,
    right: 0,
    paddingTop: 15,
    overflowX: 'auto'
  },
  contentArea: {
    maxWidth: 960,
    marginLeft: 'auto',
    marginRight: 'auto',
    paddingBottom: 90
  },
  button: {
    position: 'fixed',
    left: 0,
    bottom: 0,
    height: 60,
    width: '100%',
    cursor: 'pointer',
    textAlign: 'center',
    backgroundColor: Color.secondary
  },
  scoreboardContainer: {
    position: 'fixed',
    left: 0,
    top: 0,
    width: '100%'
  },
  scoreboard: {
    '@media (max-width: 760px)': {
      height: 90,
    },
    '@media (min-width: 760px)': {
      height: 150,
    },
    width: '100%',
    maxWidth: 960
  },
  modal: {
    position: 'fixed',
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(255, 255, 255, 0.6)'
  }
});

export const Responsive = StyleSheet.create({
  notOnMobile: {
    '@media (max-width: 760px)': {
      display: 'none'
    }
  },
  onlyOnMobile: {
    '@media (min-width: 760px)': {
      display: 'none'
    }
  },
  onlyFullWidth: {
    '@media (max-width: 960px)': {
      display: 'none'
    }
  }
});



// WEBPACK FOOTER //
// ./src/Styles.js